import script from "./ButtonRoundedTertiary.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonRoundedTertiary.vue?vue&type=script&setup=true&lang=js"

import "./ButtonRoundedTertiary.vue?vue&type=style&index=0&id=5e6d44b7&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e6d44b7"]])

export default __exports__